@if (showNavigation()) {
  <ng-container
    *ngTemplateOutlet="enableA11yHeader ? a11yHeader : legacyHeader"
  />
}

<ng-template #a11yHeader>
  <ng-container
    *ngTemplateOutlet="showMainNavigation() ? mainNav : minimalNav"
  />
</ng-template>

<ng-template #legacyHeader>
  @if (loginUrl()) {
    <wl-skip-link [loginUrl]="loginUrl()" />
    @if (minimalNavigationActive()) {
      <ed-minimal-header-container />
    } @else {
      <ed-default-header-container />
    }
  }
</ng-template>

<ng-template #mainNav>
  <wl-navigation-header>
    <wl-skip-link top [loginUrl]="loginUrl()" />

    <wl-navigation-logo
      class="d-none d-lg-block"
      left
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />
    <wl-navigation-logo
      class="d-lg-none"
      center
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />

    <wl-navigation-desktop
      class="d-none d-lg-block flex-shrink-0"
      left
      [navigationItems]="mainNavigation()?.navItems"
    />

    <wl-navigation-mobile
      class="d-lg-none"
      left
      [navigationItems]="mainNavigation()?.navItems"
      openMenuButtonText="Open navigatie menu"
      closeMenuButtonText="Sluiten"
      menuTitle="Menu"
      position="start"
    />

    @if (showLoginButton()) {
      <wl-navigation-service-button
        right
        [href]="loginUrl()"
        iconName="user"
        [text]="loginText()"
      />
    }
  </wl-navigation-header>
</ng-template>

<ng-template #minimalNav>
  <wl-navigation-header>
    <wl-skip-link top [loginUrl]="loginUrl()" [disableSkipToLogin]="true" />
    <wl-navigation-logo
      class="d-none d-lg-block"
      left
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />
    <wl-navigation-logo
      class="d-lg-none"
      center
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />

    @if (showEcmpLogo()) {
      <wl-navigation-ecmp-logo
        class="d-none d-lg-block"
        left
        [src]="ecmpLogoSource()"
        [label]="ecmpLogo().description"
        [url]="ecmpLogo().url"
        [target]="ecmpLogo().target ?? '_blank'"
      />
    }

    @if (showEcmpLogo()) {
      <wl-navigation-ecmp-logo
        class="d-lg-none"
        center
        [src]="ecmpLogoSource()"
        [label]="ecmpLogo()?.description"
        [url]="ecmpLogo()?.url"
        [target]="ecmpLogo().target ?? '_blank'"
      />
    }

    @if (showMinimalNavigationHelp()) {
      <wl-navigation-help-needed-button
        right
        text="Hulp nodig?"
        (clicked)="dispatchHelpAction()"
      />
    }
  </wl-navigation-header>
</ng-template>
